import window from 'global/window';

export const setLocalStorageValue = (key: string, value: any) => {
	try {
		window.localStorage.setItem(key, value);
		return true;
	} catch (e) {
		return false;
	}
};
